import React, { memo } from "react";
import BingTrendingTerms from "src/components/BingTrendingTerms";
import styles from "./style.css";

const BingTrendingTermsDropdown = memo(props => {
  const {
    bingTrendingTerms,
    bingTrendingStyles,
    bingTrendingTracingID,
    bingTrendingPostBackURL,
    bingTrendingFormCode,
    clientSideEnabledSearchBar,
    searchBarBingTrendingTerms,
    bingTrendingSearchType,
    searchBarBingTrendingSearchType
  } = props;

  return (
    <div class={styles.container}>
      <div class={styles.content}>
        <BingTrendingTerms
          asDropdown={true}
          bingTrendingTermsQuantity={bingTrendingTerms}
          bingTrendingStyles={bingTrendingStyles}
          bingTrendingTracingID={bingTrendingTracingID}
          bingTrendingPostBackURL={bingTrendingPostBackURL}
          formCode={bingTrendingFormCode}
          clientSideEnabledSearchBar={clientSideEnabledSearchBar}
          searchBarBingTrendingTerms={searchBarBingTrendingTerms}
          bingTrendingSearchType={bingTrendingSearchType}
          searchBarBingTrendingSearchType={searchBarBingTrendingSearchType} />
      </div>
    </div>
  );
});

export default BingTrendingTermsDropdown;
